//////////////////
// IMPORTS
//////////////////
import * as React from "react";
import { Props as ModernProps, RootModern } from "./RootModern";

//////////////////
// COMPONENT
//////////////////
// This gives us a single component that our entire Outlook app is contained under,
// allowing us to wrap the whole app very easily; e.g. for hot-loading
const RootOutlook = ({ reduxStore, isOutlook }: { isOutlook: boolean } & ModernProps) => (
  <RootModern reduxStore={reduxStore} isOutlook={isOutlook} />
);

export default RootOutlook;
